import './assets/fonts.css';


import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
// import ReactGA from "react-ga4";



const root = ReactDOM.createRoot(document.getElementById('root'));
// ReactGA.initialize("G-2J60PXF8W0"); // Replace with your Measurement ID
// ReactGA.send("pageview");

root.render(
  
  <React.StrictMode>
    <BrowserRouter>
    <App />
    </BrowserRouter>

  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
